<!-- <div class="searchable-dropdown">
    <input (click)="selectAll($event)"
           (focus)="this.isListVisible.set(true)"
           [ngModel]="filterValue()"
           (ngModelChange)="onInputChange($event)"
           class="input-M peer"
           id="salesOwner_{{instanceId()}}"
           [disabled]="disabled()"
           autocomplete="off"
           placeholder=""
           type="search"
    />
    @if (isListVisible()) {
        <ul class="list whitespace-nowrap">
            @for (option of salesOwners; track option.salesOwnerId) {
                <li class="item" (click)="onOptionSelected(option.salesOwnerId)">
                    {{ option.salesOwnerName }}
                </li>
            }
        </ul>
    }
    <label for="salesOwner_{{instanceId()}}" class="floating-c-lbl">
        Sales Executive
        @if (required()) {
            <span class="text-red-700">*</span>
        }
    </label>
</div> -->

<div class="searchable-dropdown">
    <input
            [disabled]="disabled()"
            type="text"
            id="salesOwner"
            class="textField peer"
            autocomplete="off"
            [ngModel]="filterValue()"
            (ngModelChange)="onInputChange($event)"
            (focus)="isListVisible.set(true)"
            placeholder=""
    />
    @if (isListVisible()) {
        <ul class="list">
            @for (option of salesOwners; track option.salesOwnerId) {
                <li
                        class="item"
                        [class.selected]="option.salesOwnerId === salesOwnerId()"
                        (click)="onOptionSelected(option.salesOwnerId)"
                >
                    {{ option.salesOwnerName }}
                </li>
            }
        </ul>
    }
    <label class="floating-lbl" for="salesOwner">
        Sales Executive <span class="text-red-700">*</span>
    </label>
</div>